import {
  ManagerReportsType,
  usePendingAbsenceRequestToMeQuery,
} from '../../../__generated__/graphql';

export const usePendingAbsenceRequests = (
  managerReportsType: ManagerReportsType,
) => {
  const { data, loading, error } = usePendingAbsenceRequestToMeQuery({
    variables: {
      managerReportsType,
    },
  });

  const pendingAbsenceRequestToMe = data?.me.approvalRequests ?? [];

  return {
    pendingAbsenceRequestToMe,
    error,
    loading,
  };
};
